<template>
  <div class="relative">
    <div class="background-banner flex lg:justify-start lg:pl-2 pl-4 lg:pl-6 items-start lg:items-start w-full h-76 lg:h-40">
      <div class="text-xl lg:text2xl pt-4">
        <p class="font-semibold text-banner-header text-pricing">Find the right manufacturer<br class="md:hidden"> using a sourcing expert
        </p>
        <p class="banner-text">Largest network of experts for hire <br class="md:hidden"> in major sourcing markets
        </p>
        <p class="lg:pt-6 pt-2 text-pricing text-description">Starting at 
          <span class="line-through red-text">US $499</span><br class="md:hidden">
            Launch Special Price 
          <span class="font-semibold">US $299/project</span>
        </p >
        <div class="pt-4">
        <a 
          class="hire-sourcing-btn rounded-full px-8 py-3.5 text-white text-md font-medium " 
          :href="`${baseURL}/buy/sourcing-request`"
        >
          Hire a Sourcing Expert
        </a>
        </div>
      </div>
      <div class="pt-6 lg:ml-5">
        
      </div>
    </div>
  </div>

  <freelancer-categories
    v-if="freelancerCategories.length > 2"
    :freelancerCategories="freelancerCategories"
    :selectedCategoryId="selectedCategoryId"
    @handleCategoryClick="handleCategoryClick"
    @handleCategoryReset="handleCategoryReset"
  />
  <div 
    v-if="!loading" 
    class="w-full" 
    :class="{'grid grid-cols-1 sm:grid-cols-2 card-width lg:grid-cols-4' : freelancers.length}"
  >
    <div v-if="!freelancers.length" class="w-full text-3xl text-center font-semibold">
      Freelancers are not available for the selected category. 
    </div>
    <div 
      v-for="(freelancer, index) in freelancers" 
      :key="freelancer.id_token" 
      class="flex mb-4 justify-center"
      :class="checkPosition(index+1)"
    >
       <Card :freelancer="freelancer"/>
    </div>
  </div>
  <div v-else class="flex mb-4 justify-center lg:justify-evenly"
  > 
    <ProfileContentLoader class="min-h-96-5 lg:min-h-150 w-72 lg:w-72 card-loader-width lg2:w-76 lg3:w-82 bg-white rounded-md card-shadow flex flex-col items-center relative mb-4"/>
    <ProfileContentLoader class="hidden sm:flex min-h-96-5 lg:min-h-150 w-72 lg:w-72 card-loader-width lg2:w-76 lg3:w-82 bg-white rounded-md card-shadow flex flex-col items-center relative mb-4"/>
    <ProfileContentLoader class="hidden lg:flex min-h-96-5 lg:min-h-150 w-72 lg:w-72 card-loader-width lg2:w-76 lg3:w-82 bg-white rounded-md card-shadow flex flex-col items-center relative mb-4"/>
    <ProfileContentLoader class="hidden lg:flex min-h-96-5 lg:min-h-150 w-72 lg:w-72 card-loader-width lg2:w-76 lg3:w-82 bg-white rounded-md card-shadow flex flex-col items-center relative mb-4"/>
   
  </div>

  <div class="w-full flex-row lg:flex items-center justify-center lg:justify-between ">
    <div class="lg:w-3/4 lg3:w-1/2 hidden lg:flex items-center ">
      <p class="row text-pricing text-description2">Starting at 
          <span class="line-through red-text">US $499</span>
            Launch Special Price 
          <span class="font-semibold">US $299/project</span>
      </p >
    </div>
  </div>
    <!-- Pagination -->
  <div v-if="loading" />
  <div v-else class="hidden lg:flex flex-wrap lg:flex-nowrap lg:justify-between pb-6 pt-2">
    <div class="items-center pt-4">
        <a 
          class="hire-sourcing-btn rounded-full px-8 py-3.5 text-xl text-white font-medium" 
          :href="`${baseURL}/buy/sourcing-request`">
            Hire a Sourcing Expert
        </a>
    </div>
    <div>
      <div class="w-full flex items-center text-center justify-center">
        <button v-if="this.currentPage > 1" @click="handlePreviousPage" class=""> 
          <img src="@/assets/images/previous.png" style="height:40px;" @mouseenter="hoverPaginationPreviousButton=true" @mouseleave="hoverPaginationPreviousButton=false"  :class="hoverPaginationPreviousButton ? 'hover-effect-pagination' : ''"/>
        </button>
        &nbsp;&nbsp;&nbsp;
        <button v-if="Math.ceil(this.totalResult/20) > this.currentPage" @click="handleNextPage" class="">
          <img src="@/assets/images/next.png" style="height:40px;" @mouseenter="hoverPaginationNextButton=true" @mouseleave="hoverPaginationNextButton=false" :class="hoverPaginationNextButton ? 'hover-effect-pagination' : ''"/>
        </button>
      </div>
    </div>
  </div>
  <div v-if="loading" />
  <div v-else class="lg:hidden flex flex-wrap justify-center lg:justify-between">
     <div class="pb-4">
      <div class="w-full flex items-center text-center justify-center">
        <button v-if="this.currentPage > 1" @click="handlePreviousPage" class=""> 
          <img src="@/assets/images/previous.png" style="height:40px;" @mouseenter="hoverPaginationPreviousButton=true" @mouseleave="hoverPaginationPreviousButton=false" :class="hoverPaginationPreviousButton ? 'hover-effect-pagination' : ''"/>
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button v-if="Math.ceil(this.totalResult/20) > this.currentPage" @click="handleNextPage" class="">
          <img src="@/assets/images/next.png" style="height:40px;" @mouseenter="hoverPagination=true" @mouseleave="hoverPagination=false" :class="hoverPaginationNextButton ? 'hover-effect-pagination' : ''"/>
        </button>
      </div>
    </div>
    <div class="w-full flex-row pb-2 lg:flex items-center justify-center lg:item-start lg:justify-between ">
      <div class="lg:w-3/4 lg3:w-1/2 lg:flex items-center ">
        <p class="row text-pricing text-description2">Starting at 
            <span class="line-through text-red-600">US $499</span>
            <br class="md:hidden"/>
              Launch Special Price 
            <span class="font-semibold">US $299/project</span>
        </p >
      </div>
    </div>
    <div class="sm:items-center pt-4 pb-8">
        <a 
          class="hire-sourcing-btn rounded-full px-8 py-3.5 text-xl text-white font-medium" 
          :href="`${baseURL}/buy/sourcing-request`">
            Hire a Sourcing Expert
        </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import store from '@/store/index'
import Card from '../common/Card'
import FreelancerCategories from './FreelancerCategories'
import ProfileContentLoader from './ProfileContentLoader.vue'
export default {
  components: { 
    Card,
    FreelancerCategories,
    ProfileContentLoader
  },
  
beforeRouteEnter: async (to, from, next) => {
    document.title = 'Freelance Sourcing Experts | BuyHive'
    console.log('freelancer profile', store.getters)
    if (!store.getters.isUserLoggedIn) {
      localStorage.setItem('previousUrl', window.location);
      next({name: 'LoginSelection'});
    } else if (store.getters.isUserLoggedIn && store.getters.getUserAuthInfo.role === 'buyer') {
      next()
    } else if (!store.getters.getIsEmailVerified) {
      console.log('freelancer profile || else if')
      next({ name: 'EmailVerification' })
    }else if ((store.getters.getIsEmailVerified && store.getters.getUserAuthInfo.profileVerified)) {
      console.log('freelancer profile || else if 2')
      next({ name: 'ProfileVerified' })
    } else if ((store.getters.getIsEmailVerified && !store.getters.getUserAuthInfo.profileVerified)) {
      console.log('freelancer profile || else')
      next({ name: 'AccountReview' })
    } else {
      // next();
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
    }
  },
  created() {
    this.handleFetchCategory()
    if (this.$route.query.category) {
      this.handleCategoryClick(this.$route.query.category, 1)
    } else {
      this.handleFetchAllFreelancers(this.currentPage)
    }
  },
  watch: {
    currentPage(val) {
      this.loading = true
      if (this.selectedCategoryId) {
        this.handleCategoryClick(this.selectedCategoryId, this.currentPage)
      } else this.handleFetchAllFreelancers(val)
    }
  },
  computed:{
    baseURL() {
      return process.env.VUE_APP_SERVER_BASE_URL
    },
    freelancerCategories() {
      return [...this.feautredCategories]
    }
  },
  data() {
    return{
      feautredCategories: [],
      selectedCategoryId : null,
      freelancers:[],
      totalResult: 0,
      currentPage: 1,
      loading: false,
      end_date: process.env.VUE_APP_END_DATE,
      date_suffix: process.env.VUE_APP_DATE_SUFFIX,
      end_date_month: process.env.VUE_APP_END_DATE_MONTH,
      hoverPaginationPreviousButton: false,
      hoverPaginationNextButton: false
    }
  },

  methods:{
    ...mapActions ([
      'fetchTop9Category',
      'fetchFeturedCategoryFreelancer',
      'fetchAllFreelancers'
    ]),
    async handleFetchCategory() {
      this.loading = true
      const data = await this.fetchTop9Category()
      if (data.result) {
        this.feautredCategories = data.categories
      }
      setTimeout(function(){
      this.loading = false
      },2000)
    },
   
    async handleCategoryClick(token, currentPage) {
      if (!token ) return
      if (token === 'All Categories' && currentPage > 1) {
        this.handleFetchAllFreelancers(currentPage);
        return;
      }
      if (token === 'All Categories') {
        this.handleCategoryReset()
        return
      } 
      const data = await this.fetchFeturedCategoryFreelancer({category_id: token, currentPage})
      if (data.result) {
        this.freelancers = data.freelancers
        this.totalResult = data.total_results
        this.selectedCategoryId = isNaN(token) ? token : parseInt(token)
        this.$router.push({ query: { category: `${token}`} })
        if (data.total_results > 0) this.currentPage = data.current_page
        else this.currentPage = 0
      }
      this.loading = false
    },
    async handleFetchAllFreelancers(pageNumber) {
      const data = await this.fetchAllFreelancers(pageNumber)
      if (data.result) {
        this.freelancers = data.freelancers
        this.totalResult = data.total_results
        this.currentPage = data.current_page
      } else {
        this.freelancers = []
        this.totalResult = 0
        this.currentPage = 0
      }
      this.selectedCategoryId = 'All Categories'
      this.loading = false
    },
    handleNextPage() {
      const totalPages = Math.ceil(this.totalResult/20)
      if (this.currentPage < totalPages) {
        this.currentPage = this.currentPage + 1
        window.scrollTo(0, 0)
      }
    },
    handlePreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1
        window.scrollTo(0, 0)
      }
    },
    async handleCategoryReset() {
      const data = await this.fetchAllFreelancers(1)
      if (data.result) {
        this.freelancers = data.freelancers
        this.totalResult = data.total_results
        this.currentPage = data.current_page
      } else {
        this.freelancers = []
        this.totalResult = 0
        this.currentPage = 0  
      }
      this.selectedCategoryId = 'All Categories'
      this.$router.push({ query: null})
      this.loading = false
    },
    checkPosition(pos) {
      if (pos % 4 === 0) {
        return 'lg:justify-even'
      } else if (pos % 4 === 1) {
        return 'lg:justify-even'
      }
    }
  }

  
}
</script>
<style lang="scss" scoped>
  .rotate-image{
    transform: rotate(180deg);
  }
  .text-pricing{
    color: #021A6C
  }
  .background-banner{
    border-radius: 5px;
    background-image: url('../../../../assets/images/Freelancer-2_mobile.png');
    @apply bg-right flex-col bg-cover;
    @screen lg {
      background-image: url('../../../../assets/images/category_banner.png');
      @apply bg-center bg-no-repeat flex-row;
    }
  }
  .hire-sourcing-btn {
    font-size: 14px;
    line-height: 16.8px;
    background-color: #201B59;
  }
  .card-loader-width {
    border: 1px solid rgb(229, 231, 235);
    @media (max-width: 1452px) and (min-width: 1335px) {
      width: 18.5rem;
    }
    @media (max-width: 1335px) and (min-width: 1254px) {
      width: 17rem;
    }
    @media (max-width: 1253px) and (min-width: 1201px) {
      width: 16.5rem;
    }
    @media (max-width: 1200px) and (min-width: 1154px) {
      width: 16rem;
    }
    @media (max-width: 1153px) and (min-width: 1081px) {
      width: 15rem;
    }
    @media (max-width: 1080px) and (min-width: 1024px) {
      width: 14rem;
    }
  }
  .banner-text {
    font-size: 14px;
    line-height: 15.4px;
    padding-top: 2px;
    color: #3F4254;
    @media(max-width: 768px) {
      padding-top: 4px;
    }
  }
  .text-banner-header {
    font-size: 20px;
    line-height: 22px;
    color: #201B57;
  }
  .red-text {
    color: #FE0404;
  }
 
  .text-description {
    font-size: 12px;
    line-height: 14.4px;
    @media (max-width: 768px) {
      font-size: 10px;
      line-height: 12px;
    }
  }
  .hover-effect-pagination {
    transform: scale(1.035);
  }
  .text-description2{
    font-size: 14px;
    line-height: 16.8px;
    @media (max-width: 1024px) {
      text-align: center;
      font-size: 12px;
      line-height: 14.4px;
    }
  }
</style>